/* eslint-disable react/jsx-handler-names */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import Link from '../../components/Link/Link'
import { bool } from 'prop-types'

import Menu from '@taglivros/oef_componentes/build/components/menu'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, URLS, OPCOES_MENU_VISUALIZACAO, BREAKPOINT } from '../../constants'
import { useGlobal } from '../../contexts/GlobalContext'
import { modalidadeSelecionada } from '../../utils/helpers/helpers'
import { resolverCategorias, temBookster } from '../../utils/helpers/helpersToken'
import { navigateParaBookster } from '../../utils/rotas/navigate'
import { URL_CHECKOUT_BOOKSTER } from '../../containers/Bookster/data/links'
import ModalConfirmacao from '../ModalConfirmacao/ModalConfirmacao'
import { ReactComponent as GiftIcon } from '../../assets/icons/gift.svg'

const MenuWrapperContainer = styled.div`
  height: 100%;
  li {
    margin-bottom: 0px;
  }
`

const MenuItemMGM = styled.a`
  display: flex;
  align-items: center;
  justify-content: left;

  @media (max-width: ${BREAKPOINT.md}) {
    justify-content: center;
  }

  :hover {
    svg {
      path {
        stroke: white;
      }
    }
  }

  svg {
    height: 18px;
    width: 18px;
    padding-bottom: 2px;
    margin-right: 3px;
    align-items: center;
    path {
      stroke: #4e5464;
    }
  }

  span {
    height: 18px;
    align-items: center;
  }
`

const MenuWrapper = ( { isMobile } ) => {
  const { dadosGlobaisAssociado, modalidadeURL, modalidadesDaAssinatura, setModalidadeURL, shouldShowMenu, setShowModalMgmAtHome } = useGlobal()
  const [ rotaAtual, setRotaAtual ] = useState( {} )
  const [ hasCuradoria, setHasCuradoria ] = useState( false )
  const [ hasIneditos, setHasIneditos ] = useState( false )
  const [ modalBooksterAberto, setModalBooksterAberto ] = useState( false )
  const [ verificandoBookster, setVerificandoBookster ] = useState( false )

  const abrirBookster = async( event ) => {
    if ( event ) {
      event.preventDefault()
    }
    if ( verificandoBookster ) {
      return
    }

    setVerificandoBookster( true )
    try {
      const categorias = await resolverCategorias()
      if ( temBookster( categorias ) ) {
        navigateParaBookster()
        return
      }
      setModalBooksterAberto( true )
    } finally {
      setVerificandoBookster( false )
    }
  }

  const irParaCheckoutBookster = () => {
    window.open( URL_CHECKOUT_BOOKSTER, '_blank', 'noopener,noreferrer' )
    setModalBooksterAberto( false )
  }

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas && modalidadesDaAssinatura ) {
      if ( modalidadesDaAssinatura.includes( MODALIDADE_CURADORIA.visualizacao ) ) {
        setHasCuradoria( true )
      }

      if ( modalidadesDaAssinatura.includes( MODALIDADE_INEDITOS.visualizacao ) ) {
        setHasIneditos( true )
      }
    }
  }, [ dadosGlobaisAssociado, modalidadesDaAssinatura ] )

  useEffect( () => {
    const isIneditos = modalidadeSelecionada( MODALIDADE_INEDITOS.slug )
    const isCuradoria = modalidadeSelecionada( MODALIDADE_CURADORIA.slug )
    if ( !modalidadeURL ) {
      isIneditos && setModalidadeURL( MODALIDADE_INEDITOS.slug )
      isCuradoria && setModalidadeURL( MODALIDADE_CURADORIA.slug )
    }
  }, [ modalidadeURL ] )

  const activeLink = ( route, partiallyPath = false ) => ( { isPartiallyCurrent, isCurrent } ) => {
    const current = partiallyPath ? isPartiallyCurrent : isCurrent

    if ( rotaAtual[ route ] !== current ) {
      setRotaAtual( ( state ) => ( {
        ...state,
        [ route ]: current
      } ) )
    }
  }

  if ( !( modalidadesDaAssinatura && dadosGlobaisAssociado && shouldShowMenu ) ) {
    return null
  }

  return (
    <>
      <MenuWrapperContainer
        as="aside"
        className="menu"
        isMobile={ isMobile }
      >
        <Menu isMenuMobile={ isMobile }>
          <Menu.Item
            isActive={ rotaAtual[ URLS.HOME ] }
            link={
              <Link
                getProps={ activeLink( URLS.HOME ) }
                to={ URLS.HOME }
              >
                { OPCOES_MENU_VISUALIZACAO.HOME }
              </Link>
            }
          />

          { Boolean( hasCuradoria ) &&
            <Menu.Item
              isActive={ rotaAtual[ MODALIDADE_CURADORIA.slug ] }
              link={
                <Link
                  getProps={ activeLink( MODALIDADE_CURADORIA.slug, true ) }
                  onClick={ () => setModalidadeURL( MODALIDADE_CURADORIA.slug ) }
                  to={ `/${URLS.CURADORIA}` }
                >
                  { OPCOES_MENU_VISUALIZACAO.CURADORIA }
                </Link>
              }
            /> }

          { Boolean( hasIneditos ) &&
            <Menu.Item
              isActive={ rotaAtual[ MODALIDADE_INEDITOS.slug ] }
              link={
                <Link
                  getProps={ activeLink( MODALIDADE_INEDITOS.slug, true ) }
                  onClick={ () => setModalidadeURL( MODALIDADE_INEDITOS.slug ) }
                  to={ `/${URLS.INEDITOS}` }
                >
                  { OPCOES_MENU_VISUALIZACAO.INEDITOS }
                </Link>
              }
            />}

          <Menu.Item
            link={
              <a
                href={ `/${URLS.BOOKSTER}` }
                onClick={ abrirBookster }
              >
                { OPCOES_MENU_VISUALIZACAO.BOOKSTER }
              </a>
            }
          />

          <Menu.Item
            isActive={ rotaAtual[ URLS.MEUS_KITS ] }
            link={
              <Link
                getProps={ activeLink( URLS.MEUS_KITS ) }
                to={ `/${URLS.MEUS_KITS}` }
              >
                { OPCOES_MENU_VISUALIZACAO.MEUS_KITS }
              </Link>
            }
          />

          <Menu.Item
            link={
              <MenuItemMGM
                onClick={ () => setShowModalMgmAtHome( true ) }
                rel="noopener"
                target="_blank"
              >
                <GiftIcon />

                <span>
                  { OPCOES_MENU_VISUALIZACAO.MGM }
                </span>
              </MenuItemMGM>
            }
          />

          <Menu.Item
            link={
              <a
                href={ URLS.LOJA }
                rel="noopener"
                target="_blank"
              >
                { OPCOES_MENU_VISUALIZACAO.LOJA }
              </a>
            }
          />

          <Menu.Item
            link={
              <a
                href={ URLS.DUVIDAS }
                rel="noopener"
                target="_blank"
              >
                { OPCOES_MENU_VISUALIZACAO.DUVIDAS }
              </a>
            }
          />

        </Menu>
      </MenuWrapperContainer>
      { modalBooksterAberto ? createPortal(
        <ModalConfirmacao
          acaoPrimariaTitulo="Conhecer o Bookster"
          acaoSecundariaTitulo="Voltar"
          descricao="Associados da TAG têm desconto. Associe-se aqui!"
          onClickAcaoPrimaria={ irParaCheckoutBookster }
          onClickAcaoSecundaria={ () => setModalBooksterAberto( false ) }
          titulo="Conheça o Bookster"
        />,
        document.body
      ) : null }
    </>
  )
}

MenuWrapper.propTypes = {
  'isMobile': bool.isRequired
}

export default MenuWrapper
